import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { 
    domain: String,
    errorMessage: { type: String, default: "Please enter an email address from @%DOMAIN%" },
    exceptEmail: { type: String, default: "" }
  }

  connect() {
    this.validateEmail()
  }

  validate() {
    this.validateEmail()
  }

  validateEmail() {
    if (!this.hasDomainValue) { return }
    const email = this.inputTarget.value
    
    const matchesExceptionEmail = (this.hasExceptEmailValue && email.trim() === this.exceptEmailValue.trim())
    
    const pattern = new RegExp(`^[a-zA-Z0-9._%+-]+@${this.domainValue.replace(/\./g, '\\.')}$`)
    const domain = this.domainValue

    if (email && !pattern.test(email) && !matchesExceptionEmail) {
      this.inputTarget.setCustomValidity(this.errorMessageValue.replace("%DOMAIN%", domain))
    } else {
      this.inputTarget.setCustomValidity("")
    }
  }
}
